import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  ChartConfig,
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid } from "recharts";
import { getRevenueProjection, RevenueProjectionResponse } from "@/services/adminApi";

const chartConfig: ChartConfig = {
  revenue: { label: "MRR", color: "hsl(var(--chart-1))" },
};

export function RevenueBarCard() {
  const navigate = useNavigate();
  const [data, setData] = useState<RevenueProjectionResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const res = await getRevenueProjection(navigate);
        setData(res);
      } catch {
        setError(true);
      } finally {
        setLoading(false);
      }
    })();
  }, [navigate]);

  const chartData = data
    ? [
        ...Object.entries(data.breakdown).map(([name, value]) => ({
          name: name.toUpperCase(),
          revenue: value,
        })),
        // Barre B2B (MRR per-seat agrégé) en euros, même unité que le B2C.
        ...(data.b2b ? [{ name: "B2B", revenue: data.b2b.mrr_eur }] : []),
      ]
    : [];

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-medium">MRR par segment (B2C + B2B)</CardTitle>
      </CardHeader>
      <CardContent>
        {loading ? (
          <div className="text-sm text-muted-foreground">Chargement...</div>
        ) : error ? (
          <div className="text-sm text-red-600">Erreur</div>
        ) : (
          <ChartContainer config={chartConfig} className="max-h-[250px]">
            <BarChart data={chartData}>
              <CartesianGrid vertical={false} />
              <XAxis dataKey="name" tickLine={false} axisLine={false} />
              <YAxis tickLine={false} axisLine={false} tickFormatter={(v) => `${v}\u202F\u20AC`} />
              <ChartTooltip
                content={
                  <ChartTooltipContent
                    formatter={(value) => `${value}\u202F\u20AC / mois`}
                  />
                }
              />
              <Bar dataKey="revenue" fill="var(--color-revenue)" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ChartContainer>
        )}
      </CardContent>
    </Card>
  );
}
